import config from "@/config";

let appTitle = config.title;
let loginTitle = config.title;

export function setAppTitle(payload = {}) {
  appTitle = payload.admin_title || payload.site_name || config.title;
  loginTitle = payload.login_title || payload.site_name || appTitle;
}

export function getAppTitle() {
  return appTitle;
}

export function getLoginTitle() {
  return loginTitle;
}

export function getPageTitle(pageTitle) {
  if (!pageTitle) return appTitle;
  return `${pageTitle}-${appTitle}`;
}

export function refreshPageTitle(pageTitle) {
  document.title = getPageTitle(pageTitle);
}
